var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-placeholder"},_vm._l((_vm.size),function(i){return _c('div',{key:i,staticClass:"loading-placeholder__item",style:({ width: _vm.randomWidth() + '%' })})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }